import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["generateBtn", "loadingIndicator"]

  generatePersonality(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.wizardGenerateUrl
    if (!url) return

    this.generateBtnTarget.disabled = true
    this.loadingIndicatorTarget.classList.remove("hidden")

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    // Grab current form field values
    const nameField = this.element.querySelector("[name='persona[name]']")
    const descField = this.element.querySelector("[name='persona[description]']")

    const body = new URLSearchParams()
    if (nameField) body.set("persona[name]", nameField.value)
    if (descField) body.set("persona[description]", descField.value)

    fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": token,
        "Accept": "text/vnd.turbo-stream.html",
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: body.toString()
    })
      .then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
      .catch(error => {
        console.error("[wizard] Generation failed:", error)
      })
      .finally(() => {
        this.generateBtnTarget.disabled = false
        this.loadingIndicatorTarget.classList.add("hidden")
      })
  }
}
